/**
 * Composable that returns a reactive ref indicating if the current viewport
 * is desktop-sized (>= 1024px wide)
 *
 * @returns Object with reactive `isDesktop` ref
 *
 * @example
 * const { isDesktop } = useIsDesktop()
 * // isDesktop.value will be true when window width >= 1024px
 */
export const useIsDesktop = () => {
    // Two-column (desktop) layouts start at 1025px wide
    const DESKTOP_BREAKPOINT = 1025
    const isDesktop = ref(false)

    const updateIsDesktop = () => {
        if (!import.meta.client) {
            isDesktop.value = false
            return
        }
        isDesktop.value = window.innerWidth >= DESKTOP_BREAKPOINT
    }

    // Initialize on mount
    // NOTE: this only works when used in a component's `setup` function
    onMounted(() => {
        updateIsDesktop()
        window.addEventListener('resize', updateIsDesktop)
    })

    // Clean up listener on unmount
    // NOTE: this only works when used in a component's `setup` function
    onUnmounted(() => {
        if (import.meta.client) {
            window.removeEventListener('resize', updateIsDesktop)
        }
    })
    // Blocking desktop layout for now — see doc/spec/SPEC_feature_flags_coverage.md "Deferred flags"
    // for how to bring back the `designer-desktop` flag-driven version.
    return { isDesktop: ref(false) }

    // return {
    //     isDesktop,
    // }
}
